/*
 * improvemint-finance.js — opens the "Pay over time" modal from any
 * [data-im-finance] trigger and fills it from the trigger's data-* values.
 *
 * Trigger data attributes (set by snippets/improvemint-weekly-price.liquid):
 *   data-price   cash price, cents
 *   data-weekly  weekly payment, cents
 *   data-term    number of weekly payments
 *
 * The modal's primary action is Add to cart (2026-10-21): it presses the
 * add-to-cart control the clicked weekly price belongs to — see
 * resolveTarget() below. No second add-to-cart path exists here.
 *
 * No dependencies. Idempotent (guards against double-init).
 */
(function () {
  if (window.__imFinanceInit) return;
  window.__imFinanceInit = true;

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    // Match storefront currency symbol if available, else $.
    var sym = (window.Shopify && Shopify.currency && Shopify.currency.active === 'USD') ? '$' : '$';
    return sym + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function modal() { return document.getElementById('im-finance-modal'); }

  /*
   * Early purchase. Improvemint prices this as a percentage of the cash
   * price (cash + 10%); the flat-fee branch is kept for brands that price
   * it that way. Config comes off the modal element, which reads it from
   * theme settings — the same settings the homepage calculator uses, so the
   * two surfaces can never quote different numbers.
   */
  function earlyPayoff(m, priceCents) {
    var mode = m.getAttribute('data-early-mode') || 'percent';
    if (mode === 'fee') {
      var fee = Number(m.getAttribute('data-early-fee')) || 0;
      return priceCents + fee * 100;
    }
    var pct = Number(m.getAttribute('data-early-percent')) || 0;
    return Math.round(priceCents * (1 + pct / 100));
  }

  /*
   * Add to cart (GP, 2026-10-21). The modal never adds by itself: it presses
   * the add-to-cart control the clicked weekly price belongs to, so the page's
   * own rules run unchanged (selected variant, Best Buy fulfilment writes,
   * coming-soon / unsellable blocks, quick view for multi-option cards).
   *   PDP price block (#Weekly-<section>) → #ProductSubmitButton-<section>
   *   sticky add-to-cart bar               → its submit button (form= the PDP form)
   *   product card                          → the card's visible quick-add control
   * Anything else (cart total, calculator, hero badges) has no single product,
   * so the add button stays hidden and "Learn more" stays the primary action.
   */
  var addTarget = null;

  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  function resolveTarget(trigger) {
    var wrap = trigger.closest('[id^="Weekly-"]');
    if (wrap) {
      var main = document.getElementById('ProductSubmitButton-' + wrap.id.slice('Weekly-'.length));
      if (main) return main;
    }
    var sticky = trigger.closest('sticky-atc-bar, .sticky-atc-bar, [class*="sticky-atc"]');
    if (sticky) {
      var sb = sticky.querySelector('button[type="submit"]');
      if (sb) return sb;
    }
    var card = trigger.closest('.product-card');
    if (card) {
      var acts = Array.prototype.slice.call(card.querySelectorAll('.product-card__main-actions .product-card__atc, .product-card__atc'));
      var shown = acts.filter(visible);
      return shown[0] || acts[0] || null;
    }
    return null;
  }

  function labelOf(el) {
    var t = el.querySelector('.product-card__atc-text, .btn__text');
    return ((t || el).textContent || '').replace(/\s+/g, ' ').trim();
  }

  function setupAdd(m, trigger) {
    var btn = m.querySelector('[data-im-finance-add]');
    var actions = m.querySelector('.im-modal__actions');
    if (!btn || !actions) return;
    addTarget = resolveTarget(trigger);
    if (!addTarget) {
      btn.hidden = true;
      actions.classList.remove('has-add');
      return;
    }
    var disabled = addTarget.disabled || addTarget.getAttribute('aria-disabled') === 'true';
    btn.textContent = labelOf(addTarget) || btn.getAttribute('data-default-label') || 'Add to cart';
    btn.disabled = !!disabled;
    btn.hidden = false;
    actions.classList.add('has-add');
  }

  function pressTarget() {
    var t = addTarget;
    if (!t || t.disabled) return;
    close();
    // A submit button: submit ITS form with it as the submitter, so the
    // capture-phase listeners (improvemint-pickup.js) and Hyper's product-form
    // see exactly what a click on the page's own button produces.
    var form = t.form || (t.getAttribute('form') && document.getElementById(t.getAttribute('form')));
    if (t.type === 'submit' && form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(t);
    } else {
      t.click();
    }
  }

  function open(trigger) {
    var m = modal();
    if (!m) return;
    setupAdd(m, trigger);
    var price = Number(trigger.getAttribute('data-price')) || 0;
    var weekly = Number(trigger.getAttribute('data-weekly')) || 0;
    var term = Number(trigger.getAttribute('data-term')) || 0;
    var total = weekly * term;
    var early = earlyPayoff(m, price);

    var set = function (sel, val) {
      m.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
    };
    set('[data-im-term]', term);
    set('[data-im-weekly]', money(weekly));
    set('[data-im-cash]', money(price));
    set('[data-im-cash2]', money(price));
    set('[data-im-total]', money(total));
    set('[data-im-early]', money(early));

    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('im-modal-open');
    var closeBtn = m.querySelector('.im-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    var m = modal();
    if (!m) return;
    m.hidden = true;
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('im-modal-open');
  }

  // Event delegation so it works for cards rendered after load (AJAX PLP,
  // quick view, search preview, etc.).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-im-finance]');
    if (trigger) { e.preventDefault(); open(trigger); return; }
    if (e.target.closest('[data-im-finance-add]')) { e.preventDefault(); pressTarget(); return; }
    if (e.target.closest('[data-im-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
